<template>
  <div class="multiline-function">
    <div v-for="(item, index) in multilineText" :key="index">{{ item }}</div>
  </div>
</template>
<script>
export default {
  name: 'MultilineFunction',
  props: {
    scope: Object,
  },
  computed: {
    multilineText() {
      var val = this.$getPropValue(this.scope.row, this.scope.column.property)
      if (typeof val == 'string') {
        return val.split('\n')
      }
      return []
    },
  },
}
</script>
<style lang="less">
.multiline-function {
}
</style>